import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/today")({
  beforeLoad: () => {
    // TanStack Router uses thrown redirects as control flow.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: "/opportunities",
      search: { q: "", sort: "delta", order: "desc", page: 1, filter: "all" },
      replace: true,
    });
  },
});
